export type SortDirection = "asc" | "desc";

/**
 * Compare two cell values for dashboard table sorting (Meta Ads pattern).
 * Null/undefined sort after numbers/strings when ascending, before when descending.
 */
export function compareDashboardValues(
  left: string | number | null | undefined,
  right: string | number | null | undefined,
  direction: SortDirection
): number {
  const l = left === undefined ? null : left;
  const r = right === undefined ? null : right;
  if (l === null && r === null) {
    return 0;
  }
  if (l === null) {
    return direction === "asc" ? 1 : -1;
  }
  if (r === null) {
    return direction === "asc" ? -1 : 1;
  }
  const comparison =
    typeof l === "number" && typeof r === "number"
      ? l - r
      : String(l).localeCompare(String(r));

  return direction === "asc" ? comparison : -comparison;
}

/** Same column → flip direction; new column → ascending. */
export function toggleTableSort<K>(
  current: { key: K; direction: SortDirection } | null,
  key: K
): { key: K; direction: SortDirection } {
  if (current?.key === key) {
    return { key, direction: current.direction === "asc" ? "desc" : "asc" };
  }
  return { key, direction: "asc" };
}
